export default "__VITE_ASSET__Bx9eW9VT__"